function BESSSetupMapComponent(node, latlng, zoomLevel = 15, zoomControl = false, panControl = false, id = null) {

    let mapStyles = [
        {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [{"visibility": "on"}, {"color": "#e0efef"}]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [{"visibility": "off"},]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{"lightness": 100}, {"visibility": "simplified"}]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [{"visibility": "off"}]
        },
        {
            "featureType": "water", "elementType": "all", "stylers": [{"color": "#0F7080"}]
        }];

    let googleMap = new google.maps.Map(node[0], {
        zoom: zoomLevel,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        //styles: mapStyles,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        panControl: panControl,
        zoomControl: zoomControl,
        mapId: 'BESS',
    });

    let marker = new google.maps.Marker({
        position: latlng,
        map: googleMap,
        draggable: false
    });

    node.data('googleMap', googleMap);
    node.data('marker', marker);
    return googleMap;
}